import React from 'react'

import { Container } from './styles'

import IProps from './props'

const Checkbox = ({
  id, label, checked, onCheck,
}: IProps) => (
  <Container>
    <input
      type="checkbox"
      id={id}
      name={id}
      value={id}
      onClick={onCheck}
      checked={checked}
      readOnly
    />
    <label htmlFor={id} aria-checked={checked}>
      {label}
    </label>
  </Container>
)

export default Checkbox
